import { render, staticRenderFns } from "./BudgetClarify.vue?vue&type=template&id=503f743f&"
import script from "./BudgetClarify.vue?vue&type=script&lang=ts&"
export * from "./BudgetClarify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports